module.exports = __webpack_public_path__ + "img/character_successful_order_popup.3166329c.png";